import { Directive, ElementRef, EventEmitter, Output, HostListener, Input, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[swipeBehavior]',
  standalone: true
})
export class SwipeDirective implements AfterViewInit {
  private startY = 0;
  private currentY = 0;
  private isDragging = false;
  private scrollableElement: HTMLElement | null = null;
  private hasMovedDown = false;
  private headerElement: HTMLElement | null = null;
  private backDropElement: HTMLElement | null = null;
  private isClosing = false;
  private isDarkMode = false;

  @Input() scrollContainer: HTMLElement | null = null;

  @Output() swipeDown = new EventEmitter<void>();
  @Output() swipeUp = new EventEmitter<void>();

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) { }
  darkActive
  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollableElement = this.el.nativeElement.querySelector('.bottom-pane-content') || this.el.nativeElement.querySelector('.bp-shell__content') || this.scrollContainer;
      this.headerElement = this.el.nativeElement.querySelector('.bp-shell__header');
      this.backDropElement = document.querySelector('.tt-backdrop');
      this.isDarkMode = document.getElementsByTagName('html')[0].classList.contains('ngi-theme-dark');
    }, 100);
  }

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    if (this.isClosing) return;

    const isHeaderTouch = !!(event.target as HTMLElement).closest('.bp-shell__header');
    const isAtTop = !this.scrollableElement || this.scrollableElement.scrollTop === 0;

    if (!isHeaderTouch && !isAtTop) return;

    this.startY = event.touches[0].clientY;
    this.currentY = this.startY;
    this.isDragging = true;
    this.hasMovedDown = false;

    this.renderer.setStyle(this.el.nativeElement, 'transition', 'none');
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging || this.isClosing) return;
    const isHeaderTouch = !!(event.target as HTMLElement).closest('.bp-shell__header');
    const isAtTop = !this.scrollableElement || this.scrollableElement.scrollTop === 0;

    if (!isHeaderTouch && !isAtTop) {
      this.isDragging = false;
      this.resetDrag();
      return;
    }

    this.currentY = event.touches[0].clientY;
    const deltaY = this.currentY - this.startY;

    if (deltaY > 0) {
      this.hasMovedDown = true;
      event.preventDefault();

      const resistance = 0.6;
      const translateY = deltaY * resistance;
      //backdrop animation
      this.renderer.setStyle(this.el.nativeElement, 'transform', `translateY(${translateY}px)`);
      const opacity = Math.max(0.0, (this.isDarkMode? 0.6 : 0.3) - (deltaY / 800));
      this.renderer.setStyle(this.backDropElement, 'opacity', opacity.toString());
    }
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    if (!this.isDragging || this.isClosing) return;

    const wasDragging = this.isDragging;
    const didMoveDown = this.hasMovedDown;

    this.isDragging = false;
    this.hasMovedDown = false;

    if (!wasDragging || !didMoveDown) {
      this.resetDrag();
      return;
    }

    const endY = event.changedTouches[0].clientY;
    const deltaY = endY - this.startY;

    if (deltaY > 120) {
      this.isClosing = true;
      this.renderer.addClass(this.el.nativeElement, 'swiping-closed');
      this.renderer.setStyle(this.el.nativeElement, 'transition', 'transform 0.25s ease-out, opacity 0.25s ease-out');
      this.renderer.setStyle(this.el.nativeElement, 'transform', 'translateY(100vh)');
      this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');

      // Wait for animation to complete BEFORE calling close
      setTimeout(() => {
        this.swipeDown.emit(); // close() after animation 
      }, 250);
    } else if (deltaY < -50) {      
      this.swipeUp.emit();
      this.resetDrag();
    } else {
      this.resetDrag();
    }
  }

  private resetDrag() {
    if (this.isClosing) return;

    this.renderer.setStyle(this.el.nativeElement, 'transition', 'transform 0.2s ease-out, opacity 0.2s ease-out');
    this.renderer.setStyle(this.el.nativeElement, 'transform', 'translateY(0)');
    this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
  }

  @HostListener('touchcancel')
  onTouchCancel() {
    if (this.isDragging && !this.isClosing) {
      this.isDragging = false;
      this.resetDrag();
    }
  }
}